class DateFormatter {
  static weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];
  static months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  static formatDate(date) {
    if (typeof date === 'string') {
      date = new Date(date);
    }
    if (!date) {
      return '';
    }

    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    const dayOfMonth = date.getDate();
    const weekdayIndex = date.getDay();
    const hours24 = date.getHours();
    const minutes = this.padTwoDigits(date.getMinutes());

    const hours12 = hours24 % 12;
    const hours12String = hours12 === 0 ? 12 : hours12;
    const amPm = hours12 === hours24 ? 'AM' : 'PM';

    const dateString = `${this.weekDays[weekdayIndex]}, ${this.months[monthIndex]} ${dayOfMonth} ${year}`;
    const timeString = `${hours12String}:${minutes} ${amPm}`;
    return `${dateString} - ${timeString}`;
  }

  static padTwoDigits(number) {
    return (number < 10 ? '0' : '') + number;
  }
}

export default DateFormatter;